import type {ReactElement} from 'react';
import React from 'react';
import styles from '../ai-prompt-box-attachment-preview/ai-prompt-box-attachment-preview.module.scss';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';

export interface AiPromptBoxLoadingAttachmentPreviewProps {
  id: string;
  size: AiPromptBoxSize;
  onRemove: (id: string) => void;
}

export function AiPromptBoxLoadingAttachmentPreview({id, size, onRemove}: AiPromptBoxLoadingAttachmentPreviewProps): ReactElement {
  const sizeDimensionMap = {
    [AiPromptBoxSize.SMALL]: 48,
    [AiPromptBoxSize.MEDIUM]: 56,
    [AiPromptBoxSize.SINGLE_LINE]: 48,
    [AiPromptBoxSize.SMALL_EXTENDED]: 48,
  };

  const sizeClassMap = {
    [AiPromptBoxSize.SMALL]: styles.small,
    [AiPromptBoxSize.MEDIUM]: styles.medium,
    [AiPromptBoxSize.SINGLE_LINE]: styles.small,
    [AiPromptBoxSize.SMALL_EXTENDED]: styles.small,
  };

  const dimension = sizeDimensionMap[size];

  return (
    <div className={`${styles.attachment} ${sizeClassMap[size]}`}>
      <SkeletonBrick height={dimension} width={dimension} className={`${styles.attachmentItem} spacing-m-b-2`} isPulsating={true} />
      <Icon
        className={styles.removeAttachmentButton}
        icon={'icon-close'}
        size={IconSize.SIZE_ICON_12}
        shape={IconShape.CIRCLE}
        ariaLabel={window.i18next.t('pmwjs_remove')}
        onClick={() => {
          onRemove(id);
        }}
      />
    </div>
  );
}
